import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 100,
    height: 100,
    marginTop: theme.spacing(2)
  },
  name: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1)
  },
  button: {
    marginTop: theme.spacing(4)
  }
}));
